import React from "react";
import Heading from "@widgets/heading/heading";
export function ForminatorSection(props) {
    const { section_title, section_subtitle, } = props;
    return React.createElement(React.Fragment, null,
        React.createElement(Heading, { text: section_title, tag: "h2" }),
        section_subtitle && React.createElement(Heading, { text: section_subtitle, tag: 'h4' }));
}
